import '@getgo/chameleon-web/components/Button/register'
import '@getgo/chameleon-web/components/Checkbox/register'
import '@getgo/chameleon-web/components/ToggleButton/register'
import '@getgo/chameleon-web/components/IconButton/register'
import '@getgo/chameleon-web/components/EmptyState/register'
import '@getgo/chameleon-web/components/Svg/register'
import '@getgo/chameleon-web/components/Banner/register'
import '@getgo/chameleon-web/components/Skeleton/register'
import '@getgo/chameleon-web/components/Tooltip/register'
import '@getgo/chameleon-web/components/ThemeProvider/register'
import '@getgo/chameleon-web/components/Typography/registerCustom.js'

declare const __CHAMELEON_CORE_VERSION__: string

const LINK_ID = 'chameleon-theme-style'
const CDN_BASE = 'https://chameleon.goto.com/themes'

/**
 * Registers all required Chameleon web components as side effects and
 * injects the Chameleon theme stylesheet into `document.head`.
 *
 * The stylesheet URL uses `__CHAMELEON_CORE_VERSION__`, which is replaced at
 * build time by Vite's `define` option with the version from `package.json`.
 *
 * Calling this function more than once is safe — duplicate `<link>` tags are
 * not injected.
 */
export function registerChameleonComponents(): void {
  if (!document.getElementById(LINK_ID)) {
    const link = document.createElement('link')
    link.id = LINK_ID
    link.rel = 'stylesheet'
    link.href = `${CDN_BASE}/${__CHAMELEON_CORE_VERSION__}/gotoapp.css`
    document.head.appendChild(link)
  }
}
